import classes from './AgentDebtsDialog.module.scss';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Paper, useMediaQuery } from '@mui/material';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import { BalanceTransaction } from '../data/BalanceTransaction';
import { DataGrid, GridColDef, useGridApiRef } from '@mui/x-data-grid';
import { Range } from '../data/Range.ts';
import { formatter } from '../utils.ts';
import moment from 'moment';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

export default function AgentDebtsDialog({ period, transactions, onClose }: { period: Range<Date>, transactions: BalanceTransaction[], onClose: () => void }) {

    const [dtColWidth, setDtColWidth] = useState(110);
    const [amountColWidth, setAmountColWidth] = useState(135);

    //const [columns, setColumns] = useState([] as GridColDef[]);
    const columns = [
        { field: 'TransactionDate', headerName: 'Дата', align: 'center', width: dtColWidth, valueFormatter: (value?: Date) => value ? moment(value).format("DD.MM.yyyy") : null },
        { field: 'Amount', headerName: 'Сумма', align: 'right', width: amountColWidth, headerAlign: 'center', renderCell: (params) => formatter.format(params.value) },
        { field: 'Description', flex: 1, headerName: 'Комментарий', },
    ] as GridColDef[];

    const apiRef = useGridApiRef();
    //const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        //setIsLoading(true);
        const timeoutId = setTimeout(() => {
            ReactDOM.flushSync(() => {
                //setIsLoading(false);
                apiRef.current.updateRows(transactions);
                apiRef.current.autosizeColumns({ includeOutliers: true });
            });
        }, 1000);
        return () => {
            clearInterval(timeoutId);
        };
    }, [transactions, apiRef]);


    const mobile = useMediaQuery((theme) => theme.breakpoints.down('md'));

    return (
        <Dialog
            open={true}
            onClose={onClose}
            fullWidth={true}
            fullScreen={mobile}
            //sx={{ ".MuiPaper-root": { maxWidth: "100%" } }}
            //sx={{ maxWidth: '100%' }}
            maxWidth='lg'
            className={classes.dialog}
        >
            <DialogTitle>Транзакции за период {moment(period.from).format('DD.MM.yyyy')} - {moment(period.to).format('DD.MM.yyyy')}</DialogTitle>
            <HighlightOffOutlinedIcon sx={{ position: 'absolute', right: 10, top: 10, cursor: 'pointer' }} onClick={onClose} />
            <DialogContent sx={{ height: '85vh', overflow: 'hidden', position:'relative' }}>
                <Paper sx={{ display: 'flex', pl: 2, flexDirection: 'column', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}>                    
                    <DataGrid
                        apiRef={apiRef}
                        rows={transactions}
                        density='comfortable'
                        getRowHeight={() => 'auto'}
                        getRowId={(row) => row.DocumentID}
                        initialState={{
                            sorting: {
                                sortModel: [{ field: 'TransactionDate', sort: 'desc' }],
                            },
                        }}
                        columns={columns}
                        className="timesheets-grid"
                        disableColumnMenu
                        hideFooter={transactions.length <= 100}
                        /*autosizeOptions={{
                            columns: ['TransactionDate', 'Amount',],
                            includeOutliers: true,
                            includeHeaders: true,
                            expand: true,
                        }}
                        autosizeOnMount*/
                        //disableVirtualization
                        sx={{ border: 0 }}
                    />
                </Paper>
            </DialogContent>
        </Dialog>
    );
}